import "./css/bootstrap.min.css";
import "./css/style.css";
import "./css/page_membership.css";
import "./App.css";

import { BrowserRouter } from "react-router-dom";
import Footer from "../src/components/Footer";
import Header from "../src/components/Header";
import { Provider } from "react-redux";
import React from "react";
import Routes from "./Routes";
import store from "./store";

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Header />
        <Routes />
        <Footer />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
